import React from 'react';
import { useParams } from 'react-router';
import { Field } from 'api/tasks';
import { toastService } from 'components/molecules/toast';
import { useTranslate } from 'hooks/use-translation';
import { useProjectFieldsQuery, useUpdateFieldMutation } from 'queries';
import { EventFormPage } from './event-from-page';

interface Params {
  eventId: string;
}

export const EditEventPage = (props) => {
  const { title, objectType, onClose } = props;
  const { eventId } = useParams<Params>();
  const translate = useTranslate();
  const mutation = useUpdateFieldMutation(Number(eventId), {
    onSuccess: (response) => {
      const data = response as any as Field;

      toastService({
        title: translate('settings.fields.edit.success.title'),
        message: translate('settings.fields.edit.success.message', {
          fieldLabel: data ? data?.fieldLabel ?? '' : '',
        }),
      }).success();
    },
  });

  const { data, isLoading } = useProjectFieldsQuery();
  const field = data?.find((f) => f.fieldId === Number(eventId));

  return (
    <EventFormPage
      isEdit
      isLoading={isLoading}
      onClose={onClose}
      title={title}
      mutation={mutation}
      objectType={objectType}
      field={field}
    />
  );
};
